import { render } from "./adminGiftHistory.vue?vue&type=template&id=befb3c28&scoped=true"
import script from "./adminGiftHistory.vue?vue&type=script&lang=js"
export * from "./adminGiftHistory.vue?vue&type=script&lang=js"

import "./adminGiftHistory.vue?vue&type=style&index=0&id=befb3c28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befb3c28"]])

export default __exports__